<template>
  <div class="container2">
    <div class="title2" v-if="firstLoading">
      {{ $t("FoodC_C_Bonded_package_lroO") }}
    </div>
    <template v-if="benefits.length">
      <van-list v-model="loading" :finished="finished" @load="initData">
        <div v-for="(item, index) of benefits" :key="index">
            <PackageList :list="item" :index="index+1"/>
        </div>
        <div slot="loading"></div>
        <div slot="finished">
          <div class="finished">
            {{ $t("soda-d-i18n---没有更多了") }}
          </div>
        </div>
      </van-list>
    </template>
    <div v-else-if="loading"></div>
    <template v-else>
      <div class="no-list">
        <img
          src="../../../../assets/images/couponCenter/no_result.png"
          alt=""
        />
        <div class="no-text1">{{$t('FoodC_C_No_coupon_JTJL')}}</div>
      </div>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import { List } from 'vant'
import { getPurchasableBenefits } from '@/api/couponCenter/index.js'
import { isEmpty } from 'lodash-es'
import PackageList from './package-list.vue'
import {couponPackageMarketRealexposureSw} from '../../trackEvent'
Vue.use(List)
export default {
  components: {
    PackageList,
  },
  data () {
    return {
      loading: false,
      finished: false,
      pageNo: 1,
      pageSize: 10,
      benefits: [],
      total: 0,
      firstLoading: false
    }
  },
  async mounted () {
    await this.initData()
    this.$emit('get-request-complete', {
      type: 'packageMarket',
      package_market_num: this.total,
      status: true
    })
    this.firstLoading = true
  },
  methods: {
    async initData () {
      this.loading = true
      let res = {}
      try {
        res = await getPurchasableBenefits({
          pageNo: this.pageNo,
          pageSize: this.pageSize
        })
      } catch {
        this.loading = false
        this.$emit('get-request-status', {
          status: 'err',
          type: 'packageMarket'
        })
      }
      this.loading = false
      const data = res.data
      if (!isEmpty(data)) {
        this.total = data.total
        data.benefits.map((item, index) => {
          this.handleCouponPackageMarketRealexposureSw(item, index + 1)
          this.benefits.push(item)
        })
       
        if (data.next == 1) {  // eslint-disable-line
          this.pageNo++
        } else {
          this.finished = true
        }
      } else {
        this.finished = true
      }
    },
    handleCouponPackageMarketRealexposureSw (res, index) {
      couponPackageMarketRealexposureSw({
        activity_id: res.activityID,
        benefit_id: res.benefitID,
        benefit_status: res.canPurchase === 1 ? 1 : 2,
        benefit_amount: res.price,
        index
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.title2 {
  width: 100%;
  margin-bottom:32px;
  font-family: "Aspira Medium";
  font-size: 36px;
  color: #000000;
  font-weight: 700;
  line-height: 38px;
}
.finished {
  font-family: "Aspira Regular";
  font-size: 24px;
  color: #999999;
  font-weight: 400;
  text-align: center;
  margin-bottom: 30px;
}
.no-list {
  padding-top: 19px;
  display: flex;
  align-items: center;
  flex-direction: column;

  img {
    width: 288px;
    height: 288px;
  }
  .no-text1 {
    font-family: "Aspira Medium";
    font-size: 36px;
    line-height: 38px;
    color: #000000;
    text-align: center;
    font-weight: 500;
    margin-bottom: 56px;
  }
}
</style>
